import { useSearchParams } from 'react-router-dom';
import { NewOrderTable, ReadyToShip, Shipping } from './table-renderer';
import Cancel from './table-renderer/cancel/Cancel';
import Delivered from './table-renderer/delivered/Delivered';
import Exchange from './table-renderer/exchange/Exchange';
import Return from './table-renderer/return/Return';

const TableSection = () => {
  const [searchParams] = useSearchParams();
  const orderTab = searchParams.get('orderTab');

  switch (orderTab) {
    case 'new-order':
      return <NewOrderTable />;
    case 'ready-to-ship':
      return <ReadyToShip />;
    case 'shipping':
      return <Shipping />;
    case 'delivered':
      return <Delivered />;
    case 'cancel':
      return <Cancel />;
    case 'exchange':
      return <Exchange />;
    case 'return':
      return <Return />;
    default:
      return <NewOrderTable />;
  }
};

export default TableSection;
